import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { Layout } from './components/Layout/Layout';
import { LoginPage } from './components/Auth/LoginPage';
import { UserProvider } from './contexts/UserContext';
import { Dashboard } from './pages/Dashboard';
import { Members } from './pages/Members';
import { Activities } from './pages/Activities';
import { Analytics } from './pages/Analytics';
import { MembershipFees } from './pages/MembershipFees';
import { TrackerDashboard } from './pages/TrackerDashboard';
import { AuditTrail } from './pages/AuditTrail';
import { DataManagement } from './pages/DataManagement';
import { Settings } from './pages/Settings';
import './index.css';
import './styles/responsive.css';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const LoadingSpinner = () => (
  <div className="flex items-center justify-center h-64">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-500"></div>
  </div>
);

function App() {
  // Always use MSAL authentication
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <Router basename='/tokens'>
          <div className="App">
            <AuthenticatedTemplate>
              <Layout>
                <React.Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/members" element={<Members />} />
                    <Route path="/activities" element={<Activities />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/membership-fees" element={<MembershipFees />} />
                    <Route path="/tracker-dashboard" element={<TrackerDashboard />} />
                    <Route path="/audit" element={<AuditTrail />} />
                    <Route path="/data-management" element={<DataManagement />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </React.Suspense>
              </Layout>
            </AuthenticatedTemplate>
            
            <UnauthenticatedTemplate>
              <LoginPage />
            </UnauthenticatedTemplate>
          </div>
        </Router>
        </UserProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}

export default App;